<div class="incident-checker">
	@if (incidentsDetectedAndCreated.detected > 0) {
		<mat-icon class="notification-icon" svgIcon="report_sign"></mat-icon>
		{{ incidentsDetectedAndCreated.detected }} INCIDENTS DETECTED
		{{
			allCreated === false
				? ', ' + incidentsDetectedAndCreated.created + ' INCIDENTS CREATED'
				: ', ALL CREATED'
		}}
	}
	@if (incidentsDetectedAndCreated.detected === 0) {
		<mat-icon class="notification-icon" svgIcon="report_sign"></mat-icon>
		NO INCIDENTS DETECTED
	}
	@if (dataExists) {
		<div>
			<a (click)="viewSelected()" class="incident-list-link">Show Details</a>
		</div>
	}
</div>
